// any CSS files listed here
// will be concatenated into a CSS file named after this file
import './styles/styles.scss';
